import importAll from '@core/utils/importAll'
const api = importAll(require.context('@src', true, /^\.\/[\s\S]+\/api\/[\s\S]+\.js$/))
delete api.base
export default api



// WEBPACK FOOTER //
// ./src/area-core/api/index.js